import React from 'react';
import DeliveryComponent   from '../components/Delivery';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Delivery = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Delivery</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Delivery</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <DeliveryComponent  />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <DeliveryComponent  />
        </Col>
      </Row>
    </div>
  );
};

export default Delivery;